/** Natural SS code order: SS 1, SS 2, SS 3, SS 3.1, SS 4, SS 10, SS 15.2 (not SS 1, SS 10, SS 2). */

export function ssCodeParts(code) {
  const s = String(code || '')
    .trim()
    .replace(/^SS\s*/i, '')
    .replace(/\//g, '.')
    .replace(/[^\d.]+/g, '.')
    .replace(/^\.+|\.+$/g, '');
  if (!s) return [];
  return s.split('.').map((p) => {
    const n = parseInt(p, 10);
    return Number.isFinite(n) ? n : 0;
  });
}

export function compareSsCode(a, b) {
  const pa = ssCodeParts(a);
  const pb = ssCodeParts(b);
  const n = Math.max(pa.length, pb.length);
  for (let i = 0; i < n; i++) {
    const va = i < pa.length ? pa[i] : -1;
    const vb = i < pb.length ? pb[i] : -1;
    if (va !== vb) return va - vb;
  }
  return String(a || '').localeCompare(String(b || ''), undefined, { sensitivity: 'base' });
}

function rowSsCode(row, codeKey) {
  if (row == null) return '';
  if (typeof row === 'string' || typeof row === 'number') return row;
  return row[codeKey] ?? row.code ?? row.ssCode ?? row.ss_code ?? '';
}

export function sortBySsCode(rows, codeKey = 'ss_code') {
  if (!Array.isArray(rows)) return [];
  return [...rows].sort((a, b) => compareSsCode(rowSsCode(a, codeKey), rowSsCode(b, codeKey)));
}

export function sortSsCodeStrings(codes) {
  if (!Array.isArray(codes)) return [];
  return [...codes].sort(compareSsCode);
}
